// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__O6Ti5","form":"styles_form__3nOFo"};